
import {getApi} from "~/auth";
import "~/globals";

/**
 * Upload di un documento gara tramite Web API centralizzata
 * @param data Oggetto contenente i dati del documento e il file da caricare
 * @returns Promise con la risposta contenente l'allegato salvato
 */
export async function uploadDocumentoGara(data: {
    UserId: number;
    VenditaId: number;
    Tipo: string;
    OffertaId?: number;
    AstaId?: number;
    Pin?: string;
    file: File;
    Descrizione?: string;
}): Promise<any> {
    const formData = new FormData();
    formData.append("userId", data.UserId.toString());
    formData.append("venditaId", data.VenditaId.toString());
    formData.append("tipo", data.Tipo);

    if (data.OffertaId) {
        formData.append("offertaId", data.OffertaId.toString());
    }
    if (data.AstaId) {
        formData.append("astaId", data.AstaId.toString());
    }
    if (data.Pin) {
        formData.append("pin", data.Pin);
    }
    if (data.Descrizione) {
        formData.append("descrizione", data.Descrizione);
    }

    formData.append("file", data.file);

    try {
        const url = window.BaseUrlWebApi + "Allegato/UploadDocumentoGaraAsync";

        const response = await fetch(url, {
            method: 'POST',
            body: formData,
            credentials: 'include',  // ✅ Includi i cookie per l'autenticazione
            // ❌ NON specificare Content-Type - il browser lo imposta automaticamente con il boundary corretto per multipart/form-data
        });

        if (!response.ok) {
            const errorText = await response.text();
            console.error("Errore upload documento gara:", errorText);
            return { success: false, message: errorText || "Errore durante il caricamento del documento" };
        }

        const result = await response.json();
        console.log("Documento caricato con successo.", result);
        return { success: true, data: result };

    } catch (error) {
        console.error("Errore upload documento gara:", error);
        const errorMessage = error instanceof Error ? error.message : String(error);
        return { success: false, message: errorMessage };
    }
}

export async function DeleteDocumentoGara(allegatoGaraId: number): Promise<void> {
    try {
        const url = window.BaseUrlWebApi + "Allegato/DeleteAllegatoGaraById?id=" + allegatoGaraId;

        await getApi().fetchWithAuth("DELETE " + url, {
            cache: "no-cache",
            headers: {'content-type': 'application/json'},
        });

        console.log("Documento gara cancellato con successo.");

    } catch (error) {
        console.log("Errore:", error);
    }
}

export async function DeleteDocumentoGaraByOffertaIdAndTipo(offertaId: number, tipo: string): Promise<any> {
    try {
        const url = window.BaseUrlWebApi + "Allegato/DeleteAllegatoGaraByOffertaIdAndTipo?offertaId=" + offertaId + "&tipo=" + tipo;
        const response: boolean = await getApi().fetchWithAuth("DELETE " + url, {
            cache: "no-cache",
            headers: {'content-type': 'application/json'},
        });

        console.log("Documento gara cancellato con successo.");
        return response;
        
    } catch (error) {
        console.log("Errore:", error);
    }
}

export async function DeleteDocumentoGaraByIdATByUserIdAndTipo(idAstaTelematica: number,  userId: number,tipo: string): Promise<any> {
    try {
        const url = window.BaseUrlWebApi + "Allegato/DeleteAllegatoGaraByIdATByUserIdAndTipo?idastaTelematica=" + idAstaTelematica + "&userId=" + userId+ "&tipo=" + tipo;
        const response: boolean = await getApi().fetchWithAuth("DELETE " + url, {
            cache: "no-cache",
            headers: { 'content-type': 'application/json' },
        });

        console.log("Documento gara cancellato con successo.");
        return response;

    } catch (error) {
        console.log("Errore:", error);
    }
}

export async function uploadDocumentoUtente(data: {
    UserId: number;
    TipoDoc: string;
    Numero: string;
    EnteRilascio: string;
    Scadenza: Date;
    FileFronte: File;
    FileRetro?: File;
}): Promise<any> {

    const formData = new FormData();
    formData.append("UserId", data.UserId.toString());
    formData.append("Numero", data.Numero);
    formData.append("TipoDoc", data.TipoDoc);
    formData.append("EnteRilascio", data.EnteRilascio);
    formData.append("Scadenza", data.Scadenza.toISOString());

    formData.append("FileFronte", data.FileFronte);
    if (data.FileRetro) {
        formData.append("FileRetro", data.FileRetro);
    }

    try {
        const url = window.BaseUrlWebApi + "Allegato/UploadDocumentoUtenteAsync";

        const response = await fetch(url, {
            method: 'POST',
            body: formData,
            credentials: 'include',  // ✅ Includi i cookie per l'autenticazione
            // ❌ NON specificare Content-Type - il browser lo imposta automaticamente con il boundary corretto per multipart/form-data
        });

        if (!response.ok) {
            const errorText = await response.text();
            console.error("Errore upload documento utente:", errorText);
            return { success: false, message: errorText || "Errore durante il caricamento del documento" };
        }

        const result = await response.json();
        console.log("Documento caricato con successo.", result);
        return { success: true, data: result };

    } catch (error) {
        console.error("Errore upload documento utente:", error);
        const errorMessage = error instanceof Error ? error.message : String(error);
        return { success: false, message: errorMessage };
    }
}
    